/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SDrawer, SFuncModal, SGeneralForms} from "shj-components";
import {DatePicker, Flex, Form, InputNumber, Radio, Select, Space, Spin, TimePicker, Typography} from "antd";
import {useEffect} from "react";
import {IConfig} from "shj-components/dist/es/SGeneralForms/type";
import {useRequest} from "ahooks";
import {
    queryMemberLevelList,
    saveOrUpdateBatchMemberConfiguration,
    saveOrUpdateMemberConfiguration,
    saveOrUpdateMemberEvent
} from "@/services/member.ts";
import {date2Dayjs, dateFormat} from "@/utils/date.ts";

const timeList = [{label: '天', value: 'day'}, {label: '时', value: 'hour'}, {label: '分', value: 'minute'}]
const rewardTypeList = [{label: '不限', value: '1'}, {label: '按次数', value: '2'}, {label: '按时间', value: '3'}]
const triggerTypeList = [
    {label: '立即触发', value: '1'},
    {label: '提前触发', value: '2'},
    {label: '延后触发', value: '3'},
    {label: '当天触发', value: '4'}
]

const findItem = (list: Array<any>, {value, valueKey}: { value: any, valueKey?: string }) => {
    return (list || []).find(item => item[valueKey ?? 'value'] === value);
}


/**
 * 新增编辑事件
 * @param props
 * @constructor
 */
function EditContent(props) {

    const [form] = Form.useForm();

    const {loading, runAsync} = useRequest(saveOrUpdateMemberEvent, {manual: true});

    useEffect(() => {
        form.resetFields();
        const memberRewardTimes = props.data?.memberRewardTimes || {};
        const memberTriggerTime = props.data?.memberTriggerTime || {};
        form.setFieldsValue({
            ...props?.data,
            rewardType: memberRewardTimes?.rewardType,
            times: memberRewardTimes?.times,
            timeType: memberRewardTimes?.timeType,
            triggerType: memberTriggerTime?.triggerType,
            triggerDsh: memberTriggerTime?.triggerDsh,
            triggerUnit: memberTriggerTime?.triggerUnit,
            triggerTime: date2Dayjs(memberTriggerTime?.triggerTime ? `2020-12-12 ${memberTriggerTime?.triggerTime}` : null),
            triggerMd: memberTriggerTime?.triggerMd ? date2Dayjs(memberTriggerTime?.triggerMd) : null,
        });
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            const rewardName = findItem(rewardTypeList, {value: values.rewardType})?.label;
            const triggerName = findItem(triggerTypeList, {value: values.triggerType})?.label;
            runAsync({
                ...props.data, ...values,
                rewardName,
                triggerName,
                triggerTime: values.triggerType == '4' ? (values.triggerTime ? dateFormat(values.triggerTime, 'HH:mm:00') : '00:00:00') : dateFormat(values.triggerTime, 'HH:mm:00'),
                triggerMd: values.triggerMd ? dateFormat(values.triggerMd) : null,
            }).then(() => {
                props.onClose(true);
            })
        })
    }

    const configs: Array<IConfig> = [
        {
            title: '会员事件库',
            formItem: [
                {
                    label: '事件标题',
                    name: 'title',
                    required: true,
                    spanCol: 24
                },
                {
                    label: '事件',
                    name: 'type',
                    required: true,
                    type: 'select',
                    spanCol: 24,
                    comConfig: {
                        options: props.dictData,
                        fieldNames: {label: 'name', value: 'key'},
                    }
                },
                {
                    label: '累计奖励次数',
                    spanCol: 24,
                    customRender: () => {
                        return (
                            <Form.Item label='累计奖励次数' name='rewardType' required>
                                <Radio.Group>
                                    {
                                        rewardTypeList.map(item => {
                                            if (item.value === '1') {
                                                return (
                                                    <Flex style={{padding: '2px'}}>
                                                        <Radio value={item.value}>不限</Radio>
                                                    </Flex>
                                                )
                                            }
                                            if (item.value === '2') {
                                                return (
                                                    <Flex align='center' style={{padding: '2px'}}>
                                                        <Radio value={item.value}
                                                               style={{width: '100px'}}>按次数</Radio>
                                                        <Form.Item shouldUpdate noStyle>
                                                            {
                                                                (instance) => instance.getFieldValue('rewardType') === '2' && (

                                                                    <Form.Item
                                                                        name={'times'}
                                                                        noStyle
                                                                        rules={[{required: true}]}
                                                                    >
                                                                        <InputNumber style={{width: '150px'}} min={1}
                                                                                     addonAfter='次'/>
                                                                    </Form.Item>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Flex>
                                                )
                                            }
                                            if (item.value === '3') {
                                                return (
                                                    <Flex align='center' style={{padding: '2px'}}>
                                                        <Radio style={{width: '100px'}}
                                                               value={item.value}>按时间</Radio>
                                                        <Form.Item shouldUpdate noStyle>
                                                            {
                                                                (instance) => instance.getFieldValue('rewardType') === '3' && (
                                                                    <Space.Compact>
                                                                        <Form.Item
                                                                            name={'timeType'}
                                                                            noStyle
                                                                            rules={[{required: true}]}
                                                                        >
                                                                            <Select placeholder="请选择"
                                                                                    style={{width: '150px'}}>
                                                                                <Select.Option
                                                                                    value="year">每年</Select.Option>
                                                                                <Select.Option
                                                                                    value="month">每月</Select.Option>
                                                                                <Select.Option
                                                                                    value="day">每天</Select.Option>
                                                                            </Select>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'times'}
                                                                            noStyle
                                                                            rules={[{required: true}]}
                                                                        >
                                                                            <InputNumber style={{width: '150px'}}
                                                                                         min={1}
                                                                                         addonAfter='次'/>
                                                                        </Form.Item>
                                                                    </Space.Compact>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Flex>
                                                )
                                            }
                                        })
                                    }
                                </Radio.Group>
                            </Form.Item>
                        )
                    },
                },
                {
                    label: '触发时间',
                    spanCol: 24,
                    customRender: () => {
                        return (
                            <Form.Item label='触发时间' name='triggerType' rules={[{required: true, message: '必填'}]}>
                                <Radio.Group>
                                    {
                                        triggerTypeList.map(item => {
                                            if (item.value === '1') {
                                                return (
                                                    <Flex style={{padding: '2px'}}>
                                                        <Radio value={item.value}>立即触发</Radio>
                                                    </Flex>
                                                )
                                            }
                                            if (item.value === '2') {
                                                return (
                                                    <Flex align='center' style={{padding: '2px'}}>
                                                        <Radio value={item.value}
                                                               style={{width: '100px'}}>提前触发</Radio>
                                                        <Form.Item shouldUpdate noStyle>
                                                            {
                                                                (instance) => instance.getFieldValue('triggerType') === '2' && (
                                                                    <Space.Compact>
                                                                        <Form.Item
                                                                            name={'triggerDsh'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请输入提前数量'
                                                                            }]}
                                                                        >
                                                                            <InputNumber style={{width: '140px'}}
                                                                                         min={1}
                                                                                         addonBefore='提前'/>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'triggerUnit'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请选择提前单位'
                                                                            }]}
                                                                        >
                                                                            <Select style={{width: '100px'}}
                                                                                    options={timeList}></Select>
                                                                        </Form.Item>
                                                                        <Flex align='center'>
                                                                            <Typography
                                                                                style={{marginLeft: '10px'}}>在当天的</Typography>
                                                                        </Flex>
                                                                        <Form.Item
                                                                            name={'triggerTime'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请选择提前时间'
                                                                            }]}
                                                                        >
                                                                            <TimePicker format='HH:mm'/>
                                                                        </Form.Item>
                                                                        <Flex align='center'>
                                                                            <Typography
                                                                                style={{marginLeft: '10px'}}>触发</Typography>
                                                                        </Flex>
                                                                    </Space.Compact>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Flex>
                                                )
                                            }
                                            if (item.value === '3') {
                                                return (
                                                    <Flex align='center' style={{padding: '2px'}}>
                                                        <Radio style={{width: '100px'}}
                                                               value={item.value}>延后触发</Radio>
                                                        <Form.Item shouldUpdate noStyle>
                                                            {
                                                                (instance) => instance.getFieldValue('triggerType') === '3' && (
                                                                    <Space.Compact>
                                                                        <Form.Item
                                                                            name={'triggerDsh'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请输入延后数量'
                                                                            }]}
                                                                        >
                                                                            <InputNumber style={{width: '140px'}}
                                                                                         min={1}
                                                                                         addonBefore='延后'/>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'triggerUnit'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请选择延后单位'
                                                                            }]}
                                                                        >
                                                                            <Select style={{width: '100px'}}
                                                                                    options={timeList}></Select>
                                                                        </Form.Item>
                                                                        <Flex align='center'>
                                                                            <Typography
                                                                                style={{marginLeft: '10px'}}>触发</Typography>
                                                                        </Flex>
                                                                    </Space.Compact>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Flex>
                                                )
                                            }
                                            if (item.value === '4') {
                                                return (
                                                    <Flex align='center' style={{padding: '2px'}}>
                                                        <Radio style={{width: '100px'}}
                                                               value={item.value}>当天触发</Radio>
                                                        <Form.Item shouldUpdate noStyle>
                                                            {
                                                                (instance) => instance.getFieldValue('triggerType') === '4' && (
                                                                    <Space.Compact>
                                                                        <Form.Item
                                                                            name={'triggerMd'}
                                                                            noStyle
                                                                            rules={[{
                                                                                required: true,
                                                                                message: '请选择触发周期'
                                                                            }]}
                                                                        >
                                                                            <DatePicker format='每MM月DD日'/>
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            name={'triggerTime'}
                                                                            noStyle
                                                                            // rules={[{
                                                                            //     required: true,
                                                                            //     message: '请选择触发时间'
                                                                            // }]}
                                                                        >
                                                                            <TimePicker format='HH:mm'/>
                                                                        </Form.Item>
                                                                        <Flex align='center'>
                                                                            <Typography
                                                                                style={{marginLeft: '10px'}}>触发</Typography>
                                                                        </Flex>
                                                                    </Space.Compact>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Flex>
                                                )
                                            }
                                        })
                                    }
                                </Radio.Group>
                            </Form.Item>
                        )
                    },
                },
                {
                    label: '激励发放类型',
                    name: 'grantValueType',
                    required: true,
                    type: 'radio',
                    comConfig: {
                        options: [
                            {label: '固定激励发放', value: true},
                            {label: '不固定激励发放', value: false}
                        ],
                    },
                    spanCol: 24,
                },
                {
                    label: '状态',
                    name: 'state',
                    type: 'switch',
                    spanCol: 24
                },
                {
                    label: '事件描述',
                    name: 'description',
                    type: 'textarea',
                    maxLength: 100,
                    spanCol: 24
                }
            ]
        }
    ]

    return (
        <SDrawer open={props.open} title={props.title} onSubmit={onSubmit} onClose={() => props.onClose(false)}
                 loading={loading}>
            <SGeneralForms layout='vertical' formConfig={{form}} configs={configs}></SGeneralForms>
        </SDrawer>
    )
}

export default EditContent;

/**
 * 积分配置/成长值配置
 * @param props
 * @constructor
 */
export function EditConfig(props) {

    const [form] = Form.useForm();

    const {loading, runAsync} = useRequest(saveOrUpdateMemberConfiguration, {manual: true});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(props?.data?.edit?.[0]);
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            runAsync({
                memberEventId: props?.data?.id,
                type: props?.data?.type,
                ...values
            }).then(() => {
                props.onClose(true);
            })
        })
    }

    const configs: Array<IConfig> = [
        {
            title: props.type == '2' ? '成长值配置' : '积分配置',
            formItem: [
                {
                    label: '单次奖励分值',
                    name: 'singleReward',
                    type: 'inputNumber',
                    required: true,
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '单日奖励分值上限',
                    name: 'singleRewardLimit',
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '单月奖励分值上限',
                    name: 'monthRewardLimit',
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '单日奖励上限(次数)',
                    name: 'dayLimitTimes',
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '月累计奖励限制(次数)',
                    name: 'monthLimitTimes',
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
            ]
        }
    ]

    return (
        <SDrawer open={props.open} title={props.title} onSubmit={onSubmit} onClose={() => props.onClose(false)}
                 loading={loading}>
            <SGeneralForms formConfig={{form}} layout='vertical' configs={configs}></SGeneralForms>
        </SDrawer>
    )
}

/**
 * 等级升级礼包
 * @param props
 * @constructor
 */
export function LevelContent(props) {

    const [form] = Form.useForm();

    const {loading, runAsync} = useRequest(saveOrUpdateBatchMemberConfiguration, {manual: true});
    const {loading: loadingLevel, data: memberLevelList}: any = useRequest(queryMemberLevelList, {defaultParams: [{}]});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue({});
        form.setFieldsValue(Object.assign({}, ...(props.edit || []).map(item => ({[item?.levelType]: item?.singleReward})).flat()));
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            const map = (memberLevelList || []).map(item => ({
                singleReward: values[item?.type],
                memberEventId: props?.data?.id,
                type: props?.data?.type,
                levelType: item?.type,
            }));
            runAsync(map).then(() => {
                props.destroy(true);
            })
        })
    }

    return (
        <SFuncModal.Content onOk={onSubmit} onCancel={() => props.destroy(false)} confirmLoading={loading}>
            <Typography>按会员等级单次奖励分值</Typography>
            <Spin spinning={loadingLevel}>
                <Form form={form}>
                    {
                        (memberLevelList || []).map((item) => (
                            <Form.Item label={item.name} name={item.type}>
                                <InputNumber min={0} precision={0} style={{width: '100%'}}/>
                            </Form.Item>
                        ))
                    }
                </Form>
            </Spin>
        </SFuncModal.Content>
    )
}

/**
 * 首次入会
 * @param props
 * @constructor
 */
export function OneContent(props) {

    const [form] = Form.useForm();

    const {loading, runAsync} = useRequest(saveOrUpdateMemberConfiguration, {manual: true});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(props?.edit?.[0]);
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            runAsync({
                memberEventId: props?.data?.id,
                type: props?.data?.type,
                ...values
            }).then(() => {
                props.destroy(true);
            })
        })
    }

    return (
        <SFuncModal.Content onOk={onSubmit} onCancel={() => props.destroy(false)} confirmLoading={loading}>
            <Typography>按会员等级单次奖励分值</Typography>
            <Form form={form}>
                <Form.Item label='单次奖励分值' name='singleReward' rules={[{required: true}]}>
                    <InputNumber min={0} precision={0} style={{width: '100%'}}/>
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    )
}
